import React from 'react';

class AddClass extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      theClass:'',
      Teacher:'',
      TeacherPin:'',
      TeacherEmail:'',
      Assistant:'',
      AssistantPin:'',
      AssistantEmail:'',
     WhatsappNo:'',
    }
  }

changetheClass = (event) =>{this.setState({theClass:event.target.value})}

changeTeacher = (event) =>{this.setState({Teacher:event.target.value})}

changeWhatsApp = (event) =>{this.setState({WhatsappNo:event.target.value})}

changeTeacherPin = (event) =>{this.setState({TeacherPin:event.target.value})}

changeTeacherEmail = (event) =>{this.setState({TeacherEmail:event.target.value})}

changeAssistant = (event) =>{this.setState({Assistant:event.target.value})}

changeAssistantPin = (event) =>{this.setState({AssistantPin:event.target.value})}

changeAssistantEmail = (event) =>{this.setState({AssistantEmail:event.target.value})}








  addClass = () =>{

    if(this.state.theClass === ''){

      alert('please add a child no');
    }

  else if(this.state.Teacher === ''){

      alert(`please add child's name`);
    }

    else if(this.state.TeacherPin === ''){

        alert(`please add child's surname`);
      }

      else if(this.state.Assistant === ''){

          alert(`please add child's class`);
        }
        else if(this.state.AssistantPin === ''){

            alert(`please add child's gender`);
          }

                else{
                  alert(`Adding Class/Activity \n\r
                         Class/Activity: ${this.state.theClass} \n\r
                         Teacher: ${this.state.Teacher} \n\r
                         Teacher Pin: ${this.state.TeacherPin} \n\r
                         Assistant: ${this.state.Assistant} \n\r
                         Assistant Pin: ${this.state.AssistantPin} \n\r

                         `);

                         fetch('https://schoolportal.appsdesign.co.za/add_class', {
                             method: 'post',
                             headers: {'Content-Type' : 'application/json'},
                             body: JSON.stringify({
                          classSchool:localStorage.getItem('schoolToken'),
                          assClass: this.state.theClass,
                          wapp:this.state.WhatsappNo,
                          teacher: this.state.Teacher,
                          teacherPin: this.state.TeacherPin,
                          teacherEmail: this.state.TeacherEmail,
                          assistant: this.state.Assistant,
                          assistantPin: this.state.AssistantPin,
                          assistantEmail: this.state.AssistantEmail,
                        })
                         })
                         .then(response => response)
                         .then(res =>{
                           this.setState({
                             theClass:'',
                             Teacher:'',
                             TeacherPin:'',
                             TeacherEmail:'',
                             Assistant:'',
                             AssistantPin:'',
                             AssistantEmail:'',
                             WhatsappNo:'',

                           }, function(){alert(`${res}`)})


                         })




                  }
                }


  render(){

  return(
    this.props.isAuthed ?

      <div className="ma2 pa2 br3 shadow-4" style={{display:'flex', flexDirection:'column', justifyContent:'left', margin:100, backgroundColor:'white'}}>

<div>
    <h1>Enter Class/Activity Details</h1>
    <label htmlFor="theclass" style={{marginRight:5}}>
    Class/Activity</label>
    <input
    type="text"
    placeholder="Class"
    id="theclass"
    className="pa2 ma2"
    onKeyUp={this.changetheClass}
    />
    <br/>

    <label htmlFor="whatsapp" style={{marginRight:40}}>
    WhatsApp</label>
    <input
    type="text"
    placeholder="WhatsApp Group Number"
    id="whatsapp"
    className="pa2 ma2"
    onKeyUp={this.changeWhatsApp}
    />
    <br/>

    <label htmlFor="teacher" style={{marginRight:40}}>
    Teacher</label>
    <input
    type="text"
    placeholder="Teacher"
    id="teacher"
    className="pa2 ma2"
    onKeyUp={this.changeTeacher}
    />
    <br/>

    <label htmlFor="teacherno" style={{marginRight:10}}>
    Teacher Pin</label>
    <input
    type="text"
    placeholder="Teacher Pin"
    id="teacherno"
    className="pa2 ma2"
    onKeyUp={this.changeTeacherPin}
    />
    <br/>


    <label htmlFor="teacheremail" style={{marginRight:10}}>
    Teacher Email</label>
    <input
    type="text"
    placeholder="Teacher Email"
    id="teacheremail"
    className="pa2 ma2"
    onKeyUp={this.changeTeacherEmail}
    />
    <br/>





    <label htmlFor="assistant" style={{marginRight:30}}>
    Assistant</label>
    <input
    type="text"
    placeholder="Assistant"
    id="assistant"
    className="pa2 ma2"
    onKeyUp={this.changeAssistant}
    />
    <br/>

    <label htmlFor="assistantpin">
    Assistant Pin</label>
    <input
    type="text"
    placeholder="Assistant Pin"
    id="assistantpin"
    className="pa2 ma2"
    onKeyUp={this.changeAssistantPin}
    />
    <br/>


    <label htmlFor="assistantemail">
    Assistant Email</label>
    <input
    type="text"
    placeholder="Assistant Email"
    id="assistantemail"
    className="pa2 ma2"
    onKeyUp={this.changeAssistantEmail}
    />
    <br/>









      <button className="br3 ma2 pa3 bg-blue br-blue" onClick={this.addClass}>Add Class</button>
</div>
    </div>
    :

    <h1> your out, sorry not authenticated </h1>

  )

  }

  }

export default AddClass;



// WEBPACK FOOTER //
// ./src/components/AddClass/AddClass.js